import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card hotelCard hoverShadow"
}
const _hoisted_2 = { class: "hotelCard__head" }
const _hoisted_3 = { class: "hotelCard__head__service" }
const _hoisted_4 = { class: "hotelCard__main" }
const _hoisted_5 = { class: "dataInfo" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "dataInfo__type" }, "Заезд", -1)
const _hoisted_7 = { class: "dataInfo__data" }
const _hoisted_8 = { class: "dataInfo__data__data" }
const _hoisted_9 = { class: "dayName" }
const _hoisted_10 = { class: "dataInfo__data__time" }
const _hoisted_11 = { class: "dataInfo" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "dataInfo__type" }, "Выезд", -1)
const _hoisted_13 = { class: "dataInfo__data" }
const _hoisted_14 = { class: "dataInfo__data__data" }
const _hoisted_15 = { class: "dayName" }
const _hoisted_16 = { class: "dataInfo__data__time" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"services\"><div class=\"services__title\">Услуги номера</div><ul class=\"services__list\"><li class=\"iconCond\"></li><li class=\"iconNews\"></li><li class=\"clean\"></li><li class=\"wifi\"></li><li class=\"food\"></li><li class=\"bed\"></li></ul></div>", 1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "separateBlock sepLine" }, [
  /*#__PURE__*/_createVNode("div", { class: "separateBlock__left ovalLeft" }),
  /*#__PURE__*/_createVNode("div", { class: "separateBlock__rigth ovalRight" })
], -1)
const _hoisted_19 = { class: "hotelCard__footer" }
const _hoisted_20 = { class: "infoPrice" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Итого: ")
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "*Без НДС", -1)
const _hoisted_23 = {
  key: 0,
  href: "#",
  class: "infoBtn"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.item)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.item.rooms[0].baseHotelRateAccessor.systemName), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.item.hotelName.bs.rus), 1 /* TEXT */)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", null, _toDisplayString(_ctx.parseDate(
                  _ctx.item.rooms[0].baseHotelRateAccessor.accessor.checkin,
                  "DD MMM"
                )), 1),
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.parseDate(
                  _ctx.item.rooms[0].baseHotelRateAccessor.accessor.checkin,
                  "dddd"
                )), 1)
              ]),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.item.rooms[0].baseHotelRateAccessor.checkInTime), 1)
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", null, _toDisplayString(_ctx.parseDate(
                  _ctx.item.rooms[0].baseHotelRateAccessor.accessor.checkout,
                  "DD MMM"
                )), 1),
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.parseDate(
                  _ctx.item.rooms[0].baseHotelRateAccessor.accessor.checkout,
                  "dddd"
                )), 1)
              ]),
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.item.rooms[0].baseHotelRateAccessor.checkOutTime), 1)
            ])
          ]),
          _hoisted_17
        ]),
        _hoisted_18,
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode("b", null, _toDisplayString(_ctx.item.rooms[0].extendedRatePrice.comparisionTotalPrice) + " ₽ ", 1),
            _hoisted_22
          ]),
          (!_ctx.isModeOffer)
            ? (_openBlock(), _createBlock("a", _hoisted_23, "Подробнее"))
            : _createCommentVNode("", true),
          (_ctx.isModeOffer)
            ? (_openBlock(), _createBlock("span", {
                key: 1,
                class: "infoBtn",
                onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.selectTiket(...args)), ["prevent"]))
              }, "Выбрать"))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}